import classNames from 'classnames';
import React from 'react';
import { Link } from 'gatsby';
import Style from 'styles/components/price.module.scss';
import CommonStyle from 'styles/components/common.module.scss';
import useScrollAnimation from 'hooks/useScrollAnimation';

const trustItems = [
  {
    num: '01',
    title: '隠れた費用はありません。',
    text: '表示されている料金がすべてです。追加で請求されることはありません。',
  },
  {
    num: '02',
    title: 'プラン変更が可能。',
    text: 'ショップの成長に合わせて、管理画面からプランを変更できます。',
  },
  {
    num: '03',
    title: '解約手数料は0円。',
    text: '解約時の手数料はかかりません。リスクなしではじめられるのが、comachicartの設計です。',
  },
];

const TrustSection = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.1);

  return (
    <div ref={sectionRef} className={classNames(Style.trustSection, { [Style.trustSectionVisible]: isVisible })}>
      <div className={Style.trustSection__header}>
        <span className={Style.eyebrow}>Promise</span>
        <h3 className={Style.trustSection__title}>安心して使い続けられる、3つの約束。</h3>
      </div>
      <div className={Style.trustCards}>
        {trustItems.map((item, index) => (
          <div className={Style.trustCard} key={`trust-${index}`}>
            <span className={Style.trustCard__num}>{item.num}</span>
            <div className={Style.trustCard__body}>
              <h4 className={Style.trustCard__title}>{item.title}</h4>
              <p className={Style.trustCard__text}>{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Price = ({ showIntro }) => {
  const [sectionRef, isVisible] = useScrollAnimation(0.1);

  return (
<div ref={sectionRef} className={classNames(Style.price, { [Style.price__visible]: isVisible })}>
  {showIntro && (
  <div className={Style.pricingIntro}>
    <span className={Style.eyebrow}>Pricing</span>
    <h2 className={Style.pricingIntro__title}>シンプルな料金で、安心してはじめられる。</h2>
    <p className={Style.pricingIntro__subtitle}>
      ショップを育てる時間を、コストが邪魔しない。<br />
      全プラン<span className={Style.pricingIntro__highlight}>初期費用0円</span>、<span className={Style.pricingIntro__highlight}>解約手数料なし</span>。<br />
      あなたのペースで、プランを変えられます。
    </p>
  </div>
  )}
  <div className={classNames(Style.price__title)}>料金プラン</div>
  <div className={classNames(Style.price__content)}>
    <div className={classNames(Style.price__plan)}>
      <div className={classNames(Style.price__startUpPlan__planName)}>
        <span className={classNames(Style.price__planName__en)}>Startup</span>
        <span className={classNames(Style.price__planName__ja)}>スタートアッププラン</span>
      </div>
      <div className={classNames(Style.price__details)}>
        <div className={classNames(Style.price__section)}>
          <div className={classNames(Style.price__startUpPlan__sectionTitle)}>料金</div>
          <div className={classNames(Style.price__item, Style.price__item__highlight)}>
            <div className={classNames(Style.price__label)}>初期費用</div>
            <div className={classNames(Style.price__value, Style.price__startUpPlan__value, Style.price__value__free)}>0円</div>
          </div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>月額費用</div>
            <div className={classNames(Style.price__value,Style.price__startUpPlan__value)}>0円</div>
          </div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>システム利用料*2</div>
            <div className={classNames(Style.price__value,Style.price__startUpPlan__value)}>2.5%</div>
          </div>
        </div>
        <div className={classNames(Style.price__section)}>
          <div className={classNames(Style.price__startUpPlan__sectionTitle)}>カートシステム</div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>商品画像数</div>
            <div className={classNames(Style.price__value,Style.price__startUpPlan__value)}>100枚</div>
          </div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>メルマガ配信</div>
            <div className={classNames(Style.price__value,Style.price__startUpPlan__value)}>100件</div>
          </div>
        </div>
        <div className={classNames(Style.price__section)}>
          <div className={classNames(Style.price__startUpPlan__sectionTitle)}>クレジットカード決済</div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>決済手数料*3</div>
            <div className={classNames(Style.price__value,Style.price__startUpPlan__value)}>3.2%</div>
          </div>
        </div>
      </div>
    </div>
    <div className={classNames(Style.price__basicPlan__wrapper)}>
      <div className={classNames(Style.price__basicPlan__plan)}>
        <div className={classNames(Style.price__basicPlan__planName)}>
          <span className={classNames(Style.price__planName__en)}>Basic</span>
          <span className={classNames(Style.price__planName__ja)}>ベーシックプラン</span>
        </div>
        <div className={classNames(Style.price__details)}>
          <div className={classNames(Style.price__section)}>
            <div className={classNames(Style.price__basicPlan__sectionTitle)}>料金</div>
            <div className={classNames(Style.price__item, Style.price__item__highlight)}>
              <div className={classNames(Style.price__label)}>初期費用</div>
              <div className={classNames(Style.price__value, Style.price__basicPlan__value, Style.price__value__free)}>0円</div>
            </div>
            <div className={classNames(Style.price__item)}>
              <div className={classNames(Style.price__label)}>月額費用*1</div>
              <div className={classNames(Style.price__value,Style.price__basicPlan__value)}>4,000円</div>
            </div>
            <div className={classNames(Style.price__item)}>
              <div className={classNames(Style.price__label)}>システム利用料</div>
              <div className={classNames(Style.price__value,Style.price__basicPlan__value)}>0%</div>
            </div>
          </div>
          <div className={classNames(Style.price__section)}>
            <div className={classNames(Style.price__basicPlan__sectionTitle)}>カートシステム</div>
            <div className={classNames(Style.price__item)}>
              <div className={classNames(Style.price__label)}>商品画像数</div>
              <div className={classNames(Style.price__value,Style.price__basicPlan__value)}>5,000枚</div>
            </div>
            <div className={classNames(Style.price__item)}>
              <div className={classNames(Style.price__label)}>メルマガ配信</div>
              <div className={classNames(Style.price__value,Style.price__basicPlan__value)}>10,000件</div>
            </div>
          </div>
          <div className={classNames(Style.price__section)}>
            <div className={classNames(Style.price__basicPlan__sectionTitle)}>クレジットカード決済</div>
            <div className={classNames(Style.price__item)}>
              <div className={classNames(Style.price__label)}>決済手数料*3</div>
              <div className={classNames(Style.price__value,Style.price__basicPlan__value)}>3.2%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={classNames(Style.price__plan)}>
      <div className={classNames(Style.price__professionalPlan__planName)}>
        <span className={classNames(Style.price__planName__en)}>Professional</span>
        <span className={classNames(Style.price__planName__ja)}>プロフェッショナルプラン</span>
      </div>
      <div className={classNames(Style.price__details)}>
        <div className={classNames(Style.price__section)}>
          <div className={classNames(Style.price__professionalPlan__sectionTitle)}>料金</div>
          <div className={classNames(Style.price__item, Style.price__item__highlight)}>
            <div className={classNames(Style.price__label)}>初期費用</div>
            <div className={classNames(Style.price__value, Style.price__professionalPlan__value, Style.price__value__free)}>0円</div>
          </div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>月額費用*1</div>
            <div className={classNames(Style.price__value,Style.price__professionalPlan__value)}>8,000円</div>
          </div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>システム利用料</div>
            <div className={classNames(Style.price__value,Style.price__professionalPlan__value)}>0%</div>
          </div>
        </div>
        <div className={classNames(Style.price__section)}>
          <div className={classNames(Style.price__professionalPlan__sectionTitle)}>カートシステム</div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>商品画像数</div>
            <div className={classNames(Style.price__value,Style.price__professionalPlan__value)}>50,000枚</div>
          </div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>メルマガ配信</div>
            <div className={classNames(Style.price__value,Style.price__professionalPlan__value)}>100,000件</div>
          </div>
        </div>
        <div className={classNames(Style.price__section)}>
          <div className={classNames(Style.price__professionalPlan__sectionTitle)}>クレジットカード決済</div>
          <div className={classNames(Style.price__item)}>
            <div className={classNames(Style.price__label)}>決済手数料*3</div>
            <div className={classNames(Style.price__value,Style.price__professionalPlan__value)}>3.2%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className={classNames(Style.price__notes)}>
    <p>*1 「月額費用」は税込表示となります。</p>
    <p>*2 「システム利用料」は税込表示となります。各販売ごとの売上（送料及び消費税を含む）に対して2.5%発生致します。</p>
    <p>*3 ※VISA/MASTERの場合。AMEX/JCB/DINERSは3.3%。「決済手数料」は税抜表示となります。</p>
  </div>
  {!showIntro && (
    <div className={CommonStyle.moreBtnWrapper}>
      <Link className={CommonStyle.moreBtn} to="/price/">
        詳しくはこちら
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Link>
    </div>
  )}
</div>
  );
};
export default Price;
export { TrustSection };